import { render, staticRenderFns } from "./swPostDetails.vue?vue&type=template&id=33ea3883&"
import script from "./swPostDetails.vue?vue&type=script&lang=js&"
export * from "./swPostDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports